import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-fire-line text-primary-500 mr-2"></i>
              热搜榜单
            </h2>
            <p className="text-foreground-500 text-sm">实时更新的热门吃瓜内容排行榜</p>
          </div>
          <div className="space-y-2">
            {rankingItems.map((item, idx) => (
              <a
                key={idx}
                href="#media"
                className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 hover:bg-background-200 rounded-xl transition-colors cursor-pointer no-underline group"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-100 text-secondary-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </span>
                    <span className={`px-2 py-0.5 text-xs rounded-full flex-shrink-0 whitespace-nowrap ${
                      item.tag === '独家' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '热门' ? 'bg-primary-100 text-primary-600' :
                      'bg-secondary-100 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.views}次</span>
                  <span className={`text-xs ${
                    item.trend === 'up' ? 'text-primary-500' :
                    item.trend === 'down' ? 'text-secondary-400' :
                    'text-foreground-400'
                  }`}>
                    <i className={item.trend === 'up' ? 'ri-arrow-up-line' : item.trend === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'}></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}